import addMount from "../../core/addMount";
import Menu from "./menu.entry";

addMount({ appName: "menu", app: Menu });
